import React, { useMemo, useState, useCallback } from 'react';
import useApp from '../hooks/useApp';
import useData from '../hooks/useData';
import getFloorName from '../tools/getFloorName';
import IconMarkerFav from '../icons/IconMarkerFav';
import IconMarkerSearch from '../icons/IconMarkerSearch';

const RightPanel = () => {
	const { isCHT, setCHT, setENG, activeFloor, setActiveFloor } = useApp();
	const { basicInfo, floorInfo } = useData();
	const [showFloors, setShowFloors] = useState(false);
	const [showLegends, setShowLegends] = useState(false);

	const floorList = useMemo(() => {
		const floorCount = Number(basicInfo.floorCount);
		const floorList = [];

		for (let i = 0; i < floorCount; i++) {
			floorList.push(floorInfo[i]);
		}

		return floorList;
	}, [basicInfo.floorCount, floorInfo]);

	const currentFloor = useMemo(() => {
		return floorList[activeFloor];
	}, [activeFloor, floorList]);

	const activeFloorName = useMemo(() => {
		return getFloorName(currentFloor?.floor, isCHT);
	}, [currentFloor, isCHT]);

	const setActiveFloorMobile = useCallback((index) => {
		setActiveFloor(index);
		setShowFloors(false);
	}, [setActiveFloor]);

	const toggleShowFloors = useCallback(() => {
		setShowLegends(false);
		setShowFloors(!showFloors);
	}, [showFloors]);

	const toggleShowLegends = useCallback(() => {
		setShowFloors(false);
		setShowLegends(!showLegends);
	}, [showLegends]);

	return (
		<div id='RightPanel'>
			<div className='section'>
				<div className='section-heading'>{isCHT ? '語言' : 'Language'}</div>
				<div className='flex-buttons'>
					<div className='button-wrap'>
						<div className={`button ${isCHT ? 'active' : ''}`} onClick={setCHT}>中文</div>
					</div>

					<div className='button-wrap'>
						<div className={`button ${isCHT ? '' : 'active'}`} onClick={setENG}>English</div>
					</div>
				</div>
			</div>

			<div className='section floor'>
				<div className='section-heading'>{isCHT ? '樓層' : 'Floor'}</div>
				<div className='flex-buttons'>
					{floorList.map((floor, index) => {
						const floorName = getFloorName(floor?.floor, isCHT);

						return (
							<div className='button-wrap' key={`floor${index}`}>
								<div className={`button ${activeFloor === index ? 'active' : ''}`} onClick={() => { setActiveFloor(index) }}>{floorName}</div>
							</div>
						)
					})}
				</div>
			</div>

			<div className='mobile-floors'>
				<div className='current-floor' onClick={toggleShowFloors}>{activeFloorName}</div>

				<div className={`other-floors ${showFloors ? 'active' : ''}`}>
					{floorList.map((floor, index) => {
						const floorName = getFloorName(floor?.floor, isCHT);

						if (activeFloor === index) return null;

						return (
							<div className='other-floor' key={`mobile-floor${index}`} onClick={() => { setActiveFloorMobile(index) }}>{floorName}</div>
						)
					})}
				</div>
			</div>

			<div className='section flex'>
				<div className='section-heading'>{isCHT ? '圖例' : 'Legends'}</div>
				<div className='legends'>
					<div className='legend-row'>
						<div className='legend'>
							<IconMarkerFav />
						</div>
						<div className='legend-text'>{isCHT ? '我的最愛' : 'Favourites'}</div>
					</div>

					<div className='legend-row'>
						<div className='legend'>
							<IconMarkerSearch />
						</div>
						<div className='legend-text'>{isCHT ? '搜索結果' : 'Search Result'}</div>
					</div>

					{currentFloor && currentFloor.sections.map((section, index) => {
						return (
							<div className='legend-row' key={`legend-row${index}`}>
								<div className='legend'>
									<div className='color' style={{ backgroundColor: section.fillColor }}></div>
								</div>
								<div className='legend-text'>{isCHT ? section.nameCHT : section.nameENG}</div>
							</div>
						)
					})}
				</div>
			</div>

			<div className='mobile-legends'>
				<div className='toggler' onClick={toggleShowLegends}>{isCHT ? '圖例說明' : 'Legends'}</div>

				<div className={`legends ${showLegends ? 'active' : ''}`}>
					<div className='legend-row'>
						<div className='legend'>
							<IconMarkerFav />
						</div>
						<div className='legend-text'>{isCHT ? '我的最愛' : 'Favourites'}</div>
					</div>

					<div className='legend-row'>
						<div className='legend'>
							<IconMarkerSearch />
						</div>
						<div className='legend-text'>{isCHT ? '搜索結果' : 'Search Result'}</div>
					</div>

					{currentFloor && currentFloor.sections.map((section, index) => {
						return (
							<div className='legend-row' key={`legend-row${index}`}>
								<div className='legend'>
									<div className='color' style={{ backgroundColor: section.fillColor }}></div>
								</div>
								<div className='legend-text'>{isCHT ? section.nameCHT : section.nameENG}</div>
							</div>
						)
					})}

					<div className='filler'></div>
					<div className='filler'></div>
					<div className='filler'></div>
					<div className='filler'></div>
				</div>
			</div>
		</div>
	)
}

export default RightPanel;